import React from 'react'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import JobsPage from './pages/JobsPage'
import StaffPage from './pages/StaffPage'
import ClientsPage from './pages/ClientsPage'
import SettingsPage from './pages/SettingsPage'
import PerformancePage from './pages/PerformancePage'
import LeaveApplicationPage from './pages/LeaveApplicationPage'
import AttendancePage from './pages/AttendancePage'
import Layout from './components/Layout'
import ClientSettingsPage from './pages/ClientSettingsPage'
import JobReportsPage from './pages/JobReportsPage'
import ClientReportsPage from './pages/ClientReportsPage'
import RevenueDashboardPage from './pages/RevenueDashboardPage'
import MyReportsPage from './pages/MyReportsPage'
import CheckoutPage from './pages/CheckoutPage'
import BillingPage from './pages/BillingPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import PaymentCancelledPage from './pages/PaymentCancelledPage'
import PaymentAddonSuccessPage from './pages/PaymentAddonSuccessPage'
import TrialPage from './pages/TrialPage'
import ColorReferencePage from './pages/ColorReferencePage'
import FinancePage from './pages/FinancePage'
import ArtworkHealthCheckPage from './pages/ArtworkHealthCheckPage'
import AnnouncementsPage from './pages/AnnouncementsPage'
import InkDealsPage from './pages/InkDealsPage'
import OnboardingFormPage from './pages/OnboardingFormPage'
import OnboardingPage from './pages/OnboardingPage'
import SupportPage from './pages/SupportPage'

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { token } = useAuth()
  return token ? <>{children}</> : <Navigate to="/login" />
}

function SplashScreen({ onDone }: { onDone: () => void }) {
  const [visible, setVisible] = React.useState(true)
  React.useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false)
      setTimeout(onDone, 500)
    }, 1200)
    return () => clearTimeout(t)
  }, [])
  return (
    <div className={`fixed inset-0 z-[99999] bg-white dark:bg-[#0a1628] flex items-center justify-center transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0'}`}>
      <img src="/Orange_Logo_Icon.svg" alt="Inkcredible"
        className="w-32 h-32"
        style={{
          animation: 'smoothPulse 0.8s ease-in-out infinite alternate'
        }} />
    </div>
  )
}

function App() {

  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 5000, style: { maxWidth: '420px' } }} />
        <Routes>
          {/* Public payment routes — no auth required */}
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancelled" element={<PaymentCancelledPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/onboarding/:token" element={<OnboardingFormPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardPage />} />
            <Route path="jobs" element={<JobsPage />} />
            <Route path="staff" element={<StaffPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="performance" element={<PerformancePage />} />
            <Route path="leave" element={<LeaveApplicationPage />} />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="client-settings" element={<ClientSettingsPage />} />
            <Route path="job-reports" element={<JobReportsPage />} />
            <Route path="client-reports" element={<ClientReportsPage />} />
            <Route path="revenue" element={<RevenueDashboardPage />} />
            <Route path="my-reports" element={<MyReportsPage />} />
            <Route path="announcements" element={<AnnouncementsPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="announcements" element={<AnnouncementsPage />} />
            <Route path="inkdeals" element={<InkDealsPage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="color-reference" element={<ColorReferencePage />} />
            <Route path="finance" element={<FinancePage />} />
          </Route>
          <Route path="/payment/addon-success" element={<PaymentAddonSuccessPage />} />
          <Route path="/trial" element={<TrialPage />} />
          <Route path="/artwork-check" element={<ArtworkHealthCheckPage />} />
          <Route path="/colors" element={<ColorReferencePage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  )
}

export default App